import { render } from "./DamageRelatedScreeningReport.vue?vue&type=template&id=2b386a72&ts=true"
import script from "./DamageRelatedScreeningReport.vue?vue&type=script&lang=ts"
export * from "./DamageRelatedScreeningReport.vue?vue&type=script&lang=ts"

import "./DamageRelatedScreeningReport.vue?vue&type=style&index=0&id=2b386a72&lang=scss"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__